/* Opa PDP — variants, selling plans, gallery, stores toggle, sticky bar, ajax add-to-cart (Envy cart drawer) */
(function () {
  const root = document.querySelector('[data-opa-product]');
  if (!root) return;
  const product = JSON.parse(root.querySelector('[data-opa-product-json]').textContent);
  const money = (cents) => {
    const fmt = root.dataset.moneyFormat || '${{amount}}';
    return fmt.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2));
  };
  /* Shopify names the only variant of a single-variant product "Default Title" — never show it. */
  const variantLabel = (v) => (v.title === 'Default Title' ? '' : v.title);

  /* ── Variant + plan state ── */
  const form = root.querySelector('#opa-form');
  const idInput = form.querySelector('input[name="id"]');
  const planInput = form.querySelector('input[name="selling_plan"]');
  const planSelect = root.querySelector('[data-plan-select]');
  const planRadios = root.querySelectorAll('input[name="opa-plan"]');
  const variantBtns = root.querySelectorAll('.opa-variant');
  const priceEls = root.querySelectorAll('[data-price]');
  const unitEls = root.querySelectorAll('[data-unit]');
  const subPriceEl = root.querySelector('[data-sub-price]');
  const cartBtns = root.querySelectorAll('[data-cart-btn]');

  /* Oct 15, 2026 (Vincent): a variant with no subscription plan (the 12 lb bulk cases) hides Subscribe & Save
     and falls back to one-time purchase. Bulk cases carry a one-line limit note under the size buttons:
     1 to 4 per order online (the Nexo "Bulk Purchase Limit" rule), more by phone. */
  const plansWrap = root.querySelector('.opa-plans');
  const variantsGroup = root.querySelector('.opa-buy__variants');
  let bulkNote = null;
  if (variantsGroup) {
    bulkNote = document.createElement('p');
    bulkNote.className = 'opa-qty__rule opa-bulk-note';
    bulkNote.style.cssText = 'display:none;margin:10px 0 0;line-height:1.45;';
    bulkNote.textContent = 'Up to 4 bulk cases per order online. For more, call 830-997-3358.';
    variantsGroup.insertAdjacentElement('afterend', bulkNote);
  }

  let variant = product.variants.find(v => String(v.id) === idInput.value) || product.variants[0];

  function currentPlanId() {
    const sub = [...planRadios].find(r => r.checked && r.value === 'subscribe');
    if (!sub) return '';
    return planSelect ? planSelect.value : (variant.selling_plan_allocations[0]?.selling_plan_id || '');
  }
  function allocation() {
    const pid = currentPlanId();
    if (!pid) return null;
    return variant.selling_plan_allocations.find(a => String(a.selling_plan_id) === String(pid)) || null;
  }
  function unitText() {
    const label = variantLabel(variant);
    if (!variant.unit_price) return label;
    const per = `${money(variant.unit_price)} per ${variant.unit_price_measurement.reference_unit}`;
    return label ? `${label} · ${per}` : per;
  }
  function render() {
    const canSubscribe = !!(variant.selling_plan_allocations && variant.selling_plan_allocations.length);
    if (plansWrap) {
      plansWrap.style.display = canSubscribe ? '' : 'none';
      if (!canSubscribe) {
        const once = [...planRadios].find(r => r.value === 'once');
        if (once) once.checked = true;
      }
    }
    if (bulkNote) bulkNote.style.display = /bulk case/i.test(variant.title) ? 'block' : 'none';
    idInput.value = variant.id;
    const alloc = canSubscribe ? allocation() : null;
    if (planInput) planInput.value = alloc ? alloc.selling_plan_id : '';
    const price = alloc ? alloc.price : variant.price;
    priceEls.forEach(el => el.textContent = money(price));
    unitEls.forEach(el => el.textContent = unitText());
    if (subPriceEl && variant.selling_plan_allocations.length) subPriceEl.textContent = money(variant.selling_plan_allocations[0].price);
    variantBtns.forEach(b => b.setAttribute('aria-pressed', String(Number(b.dataset.variantId) === variant.id)));
    cartBtns.forEach(b => { b.disabled = !variant.available; if (!variant.available) b.textContent = 'Sold out'; });
    if (planSelect) {
      const wrap = planSelect.closest('.opa-plan__freq');
      if (wrap) wrap.hidden = !currentPlanId();
    }
    history.replaceState(null, '', `${location.pathname}?variant=${variant.id}`);
  }
  variantBtns.forEach(b => b.addEventListener('click', () => {
    variant = product.variants.find(v => v.id === Number(b.dataset.variantId));
    render();
  }));
  planRadios.forEach(r => r.addEventListener('change', render));
  planSelect && planSelect.addEventListener('change', render);
  render();

  /* ── Ajax add to cart → Envy cart drawer ──
     Envy's drawer listens on window.eventBus for 'update:cart:drawer' (bundled section HTML) and
     'open:cart:drawer'. If the theme's cart type is not the drawer, or the bus is missing,
     the form submits normally and lands on /cart. */
  const page = document.getElementById('PageContainer');
  const drawerMode = page && page.dataset.cartType === 'drawer' && page.dataset.cartAction === 'go_to_or_open_cart';
  if (drawerMode) {
    let busy = false;
    form.addEventListener('submit', async (e) => {
      if (!window.eventBus) return; /* normal submit */
      e.preventDefault();
      if (busy) return;
      busy = true;
      const submitBtns = form.querySelectorAll('[type="submit"]');
      const labels = [...submitBtns].map(b => b.textContent);
      submitBtns.forEach(b => { b.disabled = true; b.textContent = 'Adding…'; });
      try {
        const data = new FormData(form);
        data.append('sections', 'cart-drawer');
        const res = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
          method: 'POST',
          headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: data
        });
        const json = await res.json();
        if (!res.ok) {
          window.eventBus.emit('render:cart:drawer');
          alert(json.description || json.message || 'Could not add to cart.');
        } else {
          window.eventBus.emit('update:cart:drawer', json);
          window.eventBus.emit('open:cart:drawer', { scrollToTop: true });
          try {
            const cart = await (await fetch('/cart.js')).json();
            if (window.wetheme && window.wetheme.updateCartCount) window.wetheme.updateCartCount(cart);
            document.querySelectorAll('[data-cart-count-indicator]').forEach(el => { el.textContent = cart.item_count; el.classList.toggle('hide', cart.item_count === 0); });
          } catch (_) {}
        }
      } catch (err) {
        form.submit();
        return;
      } finally {
        submitBtns.forEach((b, i) => { b.disabled = false; b.textContent = labels[i]; });
        busy = false;
      }
    });
  }

  /* ── Gallery ── */
  const mainImg = root.querySelector('#opa-gallery-main');
  root.querySelectorAll('.opa-gallery__thumb').forEach(t => t.addEventListener('click', () => {
    root.querySelectorAll('.opa-gallery__thumb').forEach(x => x.setAttribute('aria-selected', 'false'));
    t.setAttribute('aria-selected', 'true');
    mainImg.src = t.dataset.src; mainImg.srcset = t.dataset.srcset || ''; mainImg.alt = t.querySelector('img').alt;
  }));
  /* "+N" tile (Oct 12, 2026): reveals the thumbnails past the first five. */
  const moreBtn = root.querySelector('[data-opa-more-btn]');
  if (moreBtn) moreBtn.addEventListener('click', () => {
    root.querySelectorAll('.opa-gallery__thumb[data-opa-more]').forEach(t => { t.hidden = false; });
    moreBtn.hidden = true;
  });
  const track = root.querySelector('.opa-gallery__track');
  const dots = root.querySelectorAll('.opa-gallery__dots span');
  if (track && dots.length) {
    track.addEventListener('scroll', () => {
      const i = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach((d, n) => d.setAttribute('aria-current', String(n === i)));
    }, { passive: true });
  }

  /* ── Stores toggle ── */
  root.querySelectorAll('.opa-stores__toggle').forEach(btn => btn.addEventListener('click', () => {
    const panel = btn.closest('.opa-stores').querySelector('.opa-stores__panel');
    const open = panel.hidden;
    panel.hidden = !open;
    btn.setAttribute('aria-expanded', String(open));
    btn.querySelectorAll('[data-open-label]').forEach(el => el.textContent = open ? el.dataset.openLabel : el.dataset.closedLabel);
  }));

  /* ── Heating tabs (used when per-method content is configured) ── */
  const tabs = root.querySelectorAll('.opa-tab');
  tabs.forEach(tab => tab.addEventListener('click', () => {
    tabs.forEach(t => t.setAttribute('aria-selected', 'false'));
    tab.setAttribute('aria-selected', 'true');
    root.querySelectorAll('.opa-tabpanel').forEach(p => p.hidden = p.id !== tab.getAttribute('aria-controls'));
  }));

  /* ── Sticky bar ── */
  const sticky = root.querySelector('.opa-sticky');
  const sentinel = root.querySelector('[data-sticky-sentinel]');
  if (sticky && sentinel && 'IntersectionObserver' in window) {
    new IntersectionObserver(([e]) => {
      sticky.classList.toggle('is-active', !e.isIntersecting && e.boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(sentinel);
  }
})();
